var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewsTracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.849,
    height: 30.849,
    viewBox: "0 0 30.849 30.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chart-dots",
    "data-name": "Icon metro-chart-dots",
    d: "M6.427,28.921H33.419v3.856H2.571V1.928H6.427Zm4.82-1.928a2.892,2.892,0,1,1,0-5.784c.085,0,.169,0,.253.012l3.109-5.181a2.892,2.892,0,1,1,4.845,0l3.109,5.181q.126-.011.253-.012c.064,0,.128,0,.191.007l5.132-8.981A2.892,2.892,0,1,1,30.527,13.5c-.064,0-.128,0-.191-.007L25.2,22.47a2.892,2.892,0,1,1-4.812.051l-3.109-5.181c-.083.007-.167.012-.253.012s-.169,0-.253-.012L13.67,22.522a2.891,2.891,0,0,1-2.423,4.471Z",
    transform: "translate(-2.571 -1.928)",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsTracking);
export default __webpack_public_path__ + "static/media/reviewsTracking.fa623ada.svg";
export { ForwardRef as ReactComponent };